import { useRef, useState } from "react";
import { CashierForm } from "./CashierForm";
import { MyEntries } from "./MyEntries";

/**
 * The till screen = the form, then «إدخالاتي» (message 16 §7). `entry` keeps
 * the form open for the next cancellation and lists today's own records;
 * `mine` lists the whole edit window and opens the form only to correct one.
 */
export function CoEntryPanel({ scope, mode }) {
    const [editing, setEditing] = useState(null);
    const [reloadKey, setReloadKey] = useState(0);
    const top = useRef(null);

    const startEdit = (rec) => {
        setEditing(rec);
        top.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    const bump = () => setReloadKey((k) => k + 1);

    return (
        <div className="space-y-4">
            <div ref={top} className="scroll-mt-20">
                {mode === "entry" || editing ? (
                    <CashierForm key={editing?.id || "new"} scope={scope} editing={editing}
                                 onSaved={bump} onCancelEdit={() => setEditing(null)} />
                ) : null}
            </div>
            <MyEntries scope={scope} range={mode === "entry" ? "today" : "window"} reloadKey={reloadKey}
                       onEdit={startEdit} onChanged={bump} editingId={editing?.id} />
        </div>
    );
}
